import { WORKSPACE_FRAME_PADDING, WORKSPACE_PADDING } from '@components/v2/constants';
import type { RachelPresentationMode } from '../../hooks/useRachelPresentation';

const DOCKED_SPACING_BOTTOM = 0.5;

const PAGE_SPACING_BOTTOM = 4;

const OVERLAY_SPACING_BOTTOM = WORKSPACE_PADDING;

const BOTTOM_SPACING_BY_MODE: Record<RachelPresentationMode, number> = {
  docked: DOCKED_SPACING_BOTTOM,
  page: PAGE_SPACING_BOTTOM,
  overlay: OVERLAY_SPACING_BOTTOM,
  none: DOCKED_SPACING_BOTTOM,
};

export const getRachelChatLayoutBottomSpacing = (mode: RachelPresentationMode) =>
  BOTTOM_SPACING_BY_MODE[mode];

const DOCKED_INPUT_INSET_DIFF = WORKSPACE_FRAME_PADDING - WORKSPACE_PADDING;

const PENDING_ACTIONS_BOTTOM_SPACING = 1;

export const getRachelPendingActionsSpacing = (mode: RachelPresentationMode) =>
  mode === 'docked'
    ? { ml: -DOCKED_INPUT_INSET_DIFF, mr: DOCKED_INPUT_INSET_DIFF, pb: 0 }
    : { mx: 'auto', pb: PENDING_ACTIONS_BOTTOM_SPACING };
